export const rfwCampaigns = [
  {
    id: 1,
    campaignName: 'Cerveza Andes — Verano 2026',
    advertiser: 'Cervecería Andes',
    country: 'Argentina',
    state: 'Buenos Aires',
    city: 'La Plata',
    category: 'Bebidas',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 14,
    impressions: 2845000,
    clicks: 198300,
    ctr: 6.97,
    revenue: 42700,
    status: 'activa',
    startDate: '2026-01-15',
    endDate: '2026-04-15',
  },
  {
    id: 2,
    campaignName: 'Autos del Plata — Lanzamiento SUV',
    advertiser: 'Autos del Plata',
    country: 'Argentina',
    state: 'Córdoba',
    city: 'Córdoba Capital',
    category: 'Automotriz',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 9,
    impressions: 1820000,
    clicks: 98700,
    ctr: 5.42,
    revenue: 27300,
    status: 'activa',
    startDate: '2026-02-01',
    endDate: '2026-06-01',
  },
  {
    id: 3,
    campaignName: 'Seguro Total — Hogar + Auto',
    advertiser: 'Seguro Total',
    country: 'México',
    state: 'CDMX',
    city: 'Ciudad de México',
    category: 'Seguros',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 11,
    impressions: 3120000,
    clicks: 245600,
    ctr: 7.87,
    revenue: 46800,
    status: 'activa',
    startDate: '2026-01-20',
    endDate: '2026-05-20',
  },
  {
    id: 4,
    campaignName: 'Concierto Sinfónico Nacional',
    advertiser: 'Orquesta Sinfónica Nacional',
    country: 'Colombia',
    state: 'Cundinamarca',
    city: 'Bogotá',
    category: 'Eventos',
    language: 'Español',
    radioType: 'Pública',
    distributionType: 'automática',
    participatingRadios: 6,
    impressions: 940000,
    clicks: 61200,
    ctr: 6.51,
    revenue: 14100,
    status: 'finalizada',
    startDate: '2025-11-01',
    endDate: '2026-01-31',
  },
  {
    id: 5,
    campaignName: 'Banco del Sur — Cuenta Digital',
    advertiser: 'Banco del Sur',
    country: 'Chile',
    state: 'Metropolitana',
    city: 'Santiago',
    category: 'Finanzas',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 8,
    impressions: 1680000,
    clicks: 142100,
    ctr: 8.46,
    revenue: 25200,
    status: 'activa',
    startDate: '2026-03-01',
    endDate: '2026-08-01',
  },
  {
    id: 6,
    campaignName: 'Rádio Brasil — Festival de Música',
    advertiser: 'Rádio Brasil Promoções',
    country: 'Brasil',
    state: 'São Paulo',
    city: 'São Paulo',
    category: 'Música',
    language: 'Portugués',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 16,
    impressions: 3890000,
    clicks: 352400,
    ctr: 9.06,
    revenue: 58300,
    status: 'activa',
    startDate: '2026-02-15',
    endDate: '2026-07-15',
  },
  {
    id: 7,
    campaignName: 'TechNova — Smartphones Serie X',
    advertiser: 'TechNova Corp',
    country: 'Argentina',
    state: 'Santa Fe',
    city: 'Rosario',
    category: 'Tecnología',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 7,
    impressions: 1250000,
    clicks: 88200,
    ctr: 7.06,
    revenue: 18800,
    status: 'pausada',
    startDate: '2026-01-01',
    endDate: '2026-04-01',
  },
  {
    id: 8,
    campaignName: 'Restaurantes La Costa — Delivery',
    advertiser: 'Grupo La Costa',
    country: 'Perú',
    state: 'Lima',
    city: 'Lima',
    category: 'Gastronomía',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 5,
    impressions: 780000,
    clicks: 44800,
    ctr: 5.74,
    revenue: 11700,
    status: 'activa',
    startDate: '2026-03-15',
    endDate: '2026-06-15',
  },
  {
    id: 9,
    campaignName: 'Noticiero 24 — Cobertura Electoral',
    advertiser: 'Noticiero 24',
    country: 'Colombia',
    state: 'Antioquia',
    city: 'Medellín',
    category: 'Noticias',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 10,
    impressions: 2150000,
    clicks: 195300,
    ctr: 9.08,
    revenue: 32300,
    status: 'activa',
    startDate: '2026-03-01',
    endDate: '2026-06-30',
  },
  {
    id: 10,
    campaignName: 'Deportes Total — Copa América',
    advertiser: 'Deportes Total Media',
    country: 'Argentina',
    state: 'Buenos Aires',
    city: 'Mar del Plata',
    category: 'Deportes',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 12,
    impressions: 3560000,
    clicks: 324500,
    ctr: 9.12,
    revenue: 53400,
    status: 'activa',
    startDate: '2026-06-01',
    endDate: '2026-08-01',
  },
  {
    id: 11,
    campaignName: 'Rede Comunidade — Saúde Pública',
    advertiser: 'Ministério da Saúde BR',
    country: 'Brasil',
    state: 'Rio de Janeiro',
    city: 'Rio de Janeiro',
    category: 'Salud',
    language: 'Portugués',
    radioType: 'Comunitaria',
    distributionType: 'automática',
    participatingRadios: 22,
    impressions: 4980000,
    clicks: 424600,
    ctr: 8.53,
    revenue: 74700,
    status: 'activa',
    startDate: '2026-01-10',
    endDate: '2026-06-10',
  },
  {
    id: 12,
    campaignName: 'Moda Joven — Colección Otoño',
    advertiser: 'Moda Joven SA',
    country: 'México',
    state: 'Jalisco',
    city: 'Guadalajara',
    category: 'Moda',
    language: 'Español',
    radioType: 'Comercial',
    distributionType: 'automática',
    participatingRadios: 7,
    impressions: 1120000,
    clicks: 73900,
    ctr: 6.60,
    revenue: 16800,
    status: 'finalizada',
    startDate: '2025-09-01',
    endDate: '2025-12-31',
  },
];